import { peopleRef } from "@/firebase.js";

export default {
  state: {
    people: [],
    selectedContact: null
  },
  mutations: {
    setPeople (state, people) {
      state.people = people;
    }
  },
  actions: {
    async loadPeople ({ commit }) {
      peopleRef.onSnapshot(querySnapshot => {
        let peopleList = [];

        querySnapshot.forEach(person => {
          peopleList.push({ id: person.id, ...person.data() });
        });

        commit("setPeople", peopleList);
      });
    }
  },
  getters: {
    people (state) {
      return state.people;
    }
  }
};
